import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';

import { openModal } from '~/feature/authorization/authorizationModal.slice';
import { isLoggedInSelector } from '~/feature/user/isLoggedInSelector';
import { isLoggedUserCommercialAuthorSelector } from '~/feature/user/user.selector';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

export const About = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const isLoggedIn = useAppSelector(isLoggedInSelector);
  const isLoggedUserCommercialAuthor = useAppSelector(isLoggedUserCommercialAuthorSelector);

  const authorRegisterHandler = () => {
    if (isLoggedIn) {
      if (isLoggedUserCommercialAuthor) {
        router.push('/author/commercial');
        return;
      }
      router.push('/author/registration');
    } else {
      dispatch(openModal('login'));
    }
  };

  const readerRegisterHandler = () => {
    if (isLoggedIn) {
      router.push('/genre');
    } else {
      dispatch(openModal('login'));
    }
  };

  return (
    <SCAboutPage>
      <SCForWritersBackground>
        <SCContent>
          <SCHeaderRow>
            <SCBlock>
              <SCBigTitle>Bookriver</SCBigTitle>
              <SCBigText>
                литературно-издательская
                <br />
                площадка, где каждый автор
                <br />
                может найти своего читателя
              </SCBigText>
              <SCButton onClick={authorRegisterHandler}>
                Присоединиться
              </SCButton>
            </SCBlock>
          </SCHeaderRow>

          <SCForAuthorRow>
            <SCBlock>
              <SCMediumTitle>
                Bookriver для авторов
              </SCMediumTitle>
              <SCSubtitle>
                Писателем может стать каждый
              </SCSubtitle>
              <SCWave src="/icon/wave-blue.svg" alt="иконка волны" />
            </SCBlock>
          </SCForAuthorRow>

          <SCAbilitiesRow>
            <SCBlock>
              <SCImageMan />
            </SCBlock>
            <SCAbilityTextContentBlock>
              <SCSmallTitle>
                Возможность для заработка
              </SCSmallTitle>
              <SCSmallText>
                Мы — за доступность и простоту. Поэтому на Bookriver любой автор
                может быстро, просто и бесплатно получить коммерческий статус,
                чтобы продавать свои произведения — уже завершенные или в процессе написания
              </SCSmallText>
              <SCButtonGhost onClick={authorRegisterHandler}>
                Стать автором
              </SCButtonGhost>
            </SCAbilityTextContentBlock>
          </SCAbilitiesRow>

          <SCOwnAudienceRow>
            <SCBlock>

              <SCAudienceLinkRow>
                <SCBlock>
                  <SCIcon src="/icon/romb-heart.svg" alt="иконка сердца" />
                  <SCSmallTitle>
                    Своя аудитория
                  </SCSmallTitle>
                  <SCSmallText>
                    Главная задача Bookriver — помочь автору обрести своего читателя.
                    Для этого мы разрабатываем систему, которая анализирует предпочтения
                    пользователей. В результате вокруг автора формируется аудитория,
                    максимально заинтересованная в его творчестве — и набор сервисов
                    для общения и взаимодействия с ней
                  </SCSmallText>
                </SCBlock>
                <SCBlock>
                  <SCIcon src="/icon/romb-thumb-up.svg" alt="иконка лайка" />
                  <SCSmallTitle>
                    Обратная связь
                  </SCSmallTitle>
                  <SCSmallText>
                    Bookriver дает автору мощный инструмент для оценки и развития своего
                    творчества — подробную статистику. Какое произведение вызывает
                    наибольший отклик в сердцах читателей? В каком жанре автор особенно
                    хорош, а над чем еще стоит поработать? Обратная связь по произведениям
                    и отдельным главам поможет вывести писательский талант на новый уровень
                  </SCSmallText>
                </SCBlock>
              </SCAudienceLinkRow>

              <SCGoodEconomyRow>
                <SCBlock>
                  <SCIcon src="/icon/romb-wallet.svg" alt="иконка банковской карты" />
                  <SCSmallTitle>
                    Выгодное сотрудничество
                  </SCSmallTitle>
                  <SCSmallText>
                    Bookriver — площадка молодая и амбициозная :) Мы хотим собрать у себя
                    самых крутых авторов, будь то признанные профессионалы или
                    талантливые новички. Поэтому сейчас комиссия у нас — всего 20%
                    от суммы покупки, а все заработанные средства легко вывести на банковскую карту
                  </SCSmallText>
                </SCBlock>
                <SCBlock>
                  <SCIcon src="/icon/romb-shield.svg" alt="иконка щита" />
                  <SCSmallTitle>
                    Легальная экономия
                  </SCSmallTitle>
                  <SCSmallText>
                    Закон диктует свои правила, мы — помогаем его соблюдать. Для этого на
                    Bookriver предусмотрена
                    {' '}
                    <strong>регистрация статуса самозанятого</strong>
                    : так
                    автор может оптимизировать процесс уплаты налога на доход и пользоваться
                    льготной ставкой — 4 или 6% вместо 13%.
                    {' '}
                    <a
                      href="https://support.bookriver.ru/knowledge_base/item/202393?sid=47565"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Подробнее
                    </a>
                  </SCSmallText>
                </SCBlock>
              </SCGoodEconomyRow>
            </SCBlock>

          </SCOwnAudienceRow>
        </SCContent>
      </SCForWritersBackground>

      <SCForReadersBackground>
        <SCReaderBooksBackground />
        <SCContent>

          <SCForReadersRow>
            <SCBlock>
              <SCMediumTitle>
                Bookriver для читателей
              </SCMediumTitle>
              <SCSubtitle>
                Полное погружение в мир книг
              </SCSubtitle>
              <SCWave src="/icon/wave-white.svg" alt="иконка волны" />
            </SCBlock>
          </SCForReadersRow>

          <SCPersonalRecommendationsRow>
            <SCPersonalRecommendationContentBlock>
              <SCRecommendationsRow>
                <SCBlock>
                  <SCSmallTitle>
                    Персональные рекомендации
                  </SCSmallTitle>
                  <SCSmallText>
                    Время — самый ценный ресурс. Bookriver поможет находить интересные
                    книги быстрее: для этого мы разрабатываем «умную» систему рекомендаций.
                    Она учтет ваши оценки и пожелания, чтобы подбирать произведения специально
                    для вас
                  </SCSmallText>
                </SCBlock>
              </SCRecommendationsRow>
              <SCLibraryRow>
                <SCBlock>
                  <SCSmallTitle>
                    Собственная библиотека
                  </SCSmallTitle>
                  <SCSmallText>
                    На Bookriver можно сохранять произведения в свою библиотеку, оценивать их и
                    делиться с друзьями полюбившимися книгами — каждой по отдельности или целой
                    подборкой сразу
                  </SCSmallText>
                </SCBlock>
              </SCLibraryRow>
            </SCPersonalRecommendationContentBlock>
            <SCBlock>
              <SCScreenFirst />
            </SCBlock>
          </SCPersonalRecommendationsRow>

          <SCFirstInformationRow>
            <SCBlock>
              <SCScreenSecond />
            </SCBlock>
            <SCFirstInformationContentBlock>
              <SCInformationRow>
                <SCBlock>
                  <SCSmallTitle>
                    Информация из первых уст
                  </SCSmallTitle>
                  <SCSmallText>
                    На Bookriver авторы публикуют не только законченные произведения, но и книги в
                    процессе их написания. Так что читатель может следить за развитием сюжета
                    буквально «в режиме реального времени»! А еще тут же делиться эмоциями от
                    прочитанного, задавать вопросы и общаться напрямую с автором
                  </SCSmallText>
                </SCBlock>
              </SCInformationRow>
              <SCSupportRow>
                <SCBlock>
                  <SCSmallTitle>
                    Поддержка любимых авторов
                  </SCSmallTitle>
                  <SCSmallText>
                    Когда хочется выразить благодарность не только словом, но и рублем: система
                    денежных вознаграждений позволяет перечислить любую сумму на счет автору или в
                    комментариях к произведению
                  </SCSmallText>
                </SCBlock>
              </SCSupportRow>
            </SCFirstInformationContentBlock>
          </SCFirstInformationRow>

          <SCBookCommunityRow>
            <SCBookCommunityContentBlock>
              <SCCommunityRow>
                <SCBlock>
                  <SCSmallTitle>
                    Книжное сообщество
                  </SCSmallTitle>
                  <SCSmallText>
                    Находите единомышленников, подписывайтесь на интересных авторов, общайтесь в
                    личных сообщениях — мир книг захватывает вдвойне, когда его есть с кем разделить
                  </SCSmallText>
                </SCBlock>
              </SCCommunityRow>
              <SCWritersRow>
                <SCBlock>
                  <SCSmallTitle>
                    Легкий путь к писательству
                  </SCSmallTitle>
                  <SCSmallText>
                    Истина: чем больше читаешь, тем больше хочется попробовать писать самому.
                    И это здорово! Мы поможем сделать первые шаги
                  </SCSmallText>
                </SCBlock>
              </SCWritersRow>
            </SCBookCommunityContentBlock>
            <SCBlock>
              <SCScreenThird />
            </SCBlock>
          </SCBookCommunityRow>

          <SCJoinUsRow>
            <SCBlock>
              <SCTitle>
                Присоединяйтесь к сообществу Bookriver —
                напишите свою историю успеха!
              </SCTitle>
              <SCSubtitle>
                Итак, какой путь выбираете вы?
              </SCSubtitle>
            </SCBlock>
          </SCJoinUsRow>

          <SCButtonsRow>
            <SCButtonBlue onClick={readerRegisterHandler}>
              Стать читателем
            </SCButtonBlue>
            <SCButtonYellow onClick={authorRegisterHandler}>
              Стать автором
            </SCButtonYellow>
          </SCButtonsRow>

        </SCContent>
        <SCCurve />
      </SCForReadersBackground>
    </SCAboutPage>
  );
};

const SCReaderBooksBackground = styled.div`
  width: 100%;
  height: 800px;
  position: absolute;
  user-select: none;
  pointer-events: none;
  right: 0;
  left: 0;
  z-index: 0;
  background-image: url("/image/books-background.jpg");
  background-position: center center;
  background-color: #2D3848;
  background-repeat: no-repeat;
  opacity: 0.4;

  mask-image: linear-gradient(to top, transparent 10%, #2d3848);
  mask-size: cover;
  mask-position: center center;
  mask-repeat: no-repeat;

  ${lessThan('md')} {
    height: 400px;
  }
`;

const SCCurve = styled.div`
  position: absolute;
  bottom: 0;
  left: -2px;
  width: 100%;
  height: 119px;
  background-image: url('/image/curve.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  box-shadow: 0 7px 0 0 #fff;
`;

const SCScreenThird = styled.div`
  z-index: 2;
  position: relative;
  border-radius: 40px 0;
  background: #2883ED;
  
  width: 299px;
  height: 367px;
  
  transform: translate(50px, 120px);
  
  &:after {
      position: absolute;
      z-index: 3;
      display: block;
      content: '';
      background-image: url("/image/third-screen.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 930px;
      height: 706px;
      transform: scale(1.1) translate(-20px, -220px);
    }
    
    &:before {
      position: absolute;
      z-index: 2;
      display: block;
      content: '';
      width: 299px;
      height: 367px;
      background: #2883ED;
      border-radius: 40px 0;
      transform: translate(350px, -185px);
    }
  
  
  ${lessThan('md')} {
    width: 168.16px;
    height: 206.4px;
    margin-bottom: 112px;
    
    transform: translate(-50px, 50px);
    
    &:after {
      position: absolute;
      z-index: 3;
      display: block;
      content: '';
      background-image: url("/image/third-screen.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transform: scale(1.1);
      width: 400px;
      height: 290px;
      left: -5px;
      top: -55px
    }
    
    &:before {
      position: absolute;
      z-index: 2;
      display: block;
      content: '';
      width: 168.16px;
      height: 206.4px;
      transform: translate(200px, -40px);
      background: #2883ED;
      border-radius: 40px 0;
    }
  } 
`;

const SCScreenFirst = styled.div`
  width: 299px;
  height: 367px;
  position: relative;
  z-index: 1;
  background: #F57300;
  border-radius: 40px 0;
  transform: rotate(-180deg) scale(1.2) translate(-60px, -70px);
  
  ${lessThan('md')} {
    width: 161px;
    height: 196px;
    
    left: -65px;
    
    margin-bottom: 52px;
    
    transform: rotate(-180deg);

  } 
  
  &:after {
    width: 728px;
    height: 580px;
    display: block;
    position: absolute;
    content: '';
    background-image: url('/image/first-screen.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    left: -440px;
    top: -70px;
    transform: scale(-1);
    
  
    ${lessThan('md')} {
      width: 391.71px;
      height: 312.07px;
      left: -305px;
      top: -5px;
      transform: scale(-1.35);
    } 
  }
`;

const SCScreenSecond = styled.div`
  position: relative;
  z-index: 1;
  background: #F2C94C;
  border-radius: 40px 0;
  width: 299px;
  height: 367px;
  transform: rotate(-180deg) translate(-130px, -220px);
  
  ${lessThan('md')} {
    width: 161px;
    height: 196px;
    
    transform: translateX(65px);
    
    margin-left: auto;
    margin-right: auto;
    
    margin-bottom: 52px;
  } 
  
  &:after {
    display: block;
    position: absolute;
    content: '';
    background-image: url('/image/second-screen.png');
    background-repeat: no-repeat;
    background-size: contain;
    width: 728px;
    height: 537px;
    transform: scale(-1.35) translate(-90px, 60px);
      
    ${lessThan('md')} {
      transform: scale(1);
      width: 520px;
      height: 290.08px;
      left: -360px;
      top: -95px;
    } 
  }
`;

const SCImageMan = styled.div`
  display: block;
  position: relative;
  width: 299px;
  height: 367px;
  z-index: 1;
  transform: translate(40px, 100px);
  
  background: #2883ED;
  border-radius: 40px 0;
  
  ${lessThan('md')} {
    width: 190px;
    height: 233px;
    margin-bottom: 10px;
  } 
  
  &:before {
    display: block;
    background-position: center center;
    background-image: url("/image/man.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    content: '';
    position: absolute;
    width: 299px;
    height: 367px;
    left: -30px;
    top: -55px;

    border-radius: 40px 0;
    
    ${lessThan('md')} {
      width: 235px;
      height: 290px;
      left: -70px;
      top: -90px;
    } 
  }
`;

const SCIcon = styled.img`
  margin-bottom: 28px;
  width: 100px;
  height: 100px;
`;

const SCWave = styled.img`

`;

const SCButtonGhost = styled.button`
  background: transparent;
  border-radius: 40px;
  font-family: var(--main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #2D3848;
  padding: 20px 36px;
  border: 2px solid #2D3848;
  cursor: pointer;
  
  &:focus {
    outline: unset;
  }
  
  &:hover {
    background: #2D3848;
    color: var(--white-color);
    border: unset;
    padding: 22px 36px;
  }
`;

const SCButton = styled.button`
  background: #2D3848;
  border-radius: 40px;
  font-family: var(--main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: var(--white-color);
  padding: 20px 36px;
  border: unset;
  cursor: pointer;
  
  &:focus {
    outline: unset;
  }
  
  &:hover {
    filter: brightness(1.4);
  }
`;

const SCButtonBlue = styled(SCButton)`
  background-color: var(--primary-color);
  
  margin-right: 60px;
  margin-left: auto;
  
  ${lessThan('md')} {
    width: 264px;
    height: 56px;
    padding-top: 16px;
    padding-bottom: 16px;
    margin-right: auto;
    margin-left: auto;
    
    margin-bottom: 28px;
  }
`;

const SCButtonYellow = styled(SCButton)`
  color: var(--black-color);
  background-color: var(--yellow-dark-color);
  
  margin-right: auto;
  margin-left: 0;
  
  ${lessThan('md')} {
    width: 264px;
    height: 56px;
    margin-right: auto;
    margin-left: auto;
    padding-top: 16px;
    padding-bottom: 16px;
  }
`;

const SCRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  
  ${lessThan('md')} {
   flex-direction: column;
   align-items: center;
  }
`;

const SCSmallText = styled.p`
  font-family: var(--main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  color: #70797B;
  
  ${lessThan('md')} {
    text-align: center;
    font-size: 15px;
    line-height: 20px;
  }
`;

const SCSmallTitle = styled.h4`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 24px;
  margin-bottom: 32px;
  
  color: var(--black-color);
  
  ${lessThan('md')} {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
  }
`;

const SCSubtitle = styled.h4`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 24px;
  margin-left: auto;
  margin-right: auto;
  
  ${lessThan('md')} {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
  }
`;

const SCBigText = styled.p`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 48px;
  color: var(--black-color);
  
  ${lessThan('md')} {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    color: var(--white-color);
  }
`;

const SCMediumTitle = styled.h2`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 40px;
  line-height: 48px;
  color: var(--black-color);
  
  ${lessThan('md')} {
    text-align: center;
    font-size: 20px;
    line-height: 48px;
  }
`;

const SCBigTitle = styled.h1`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 48px;
  color: var(--black-color);
  
  ${lessThan('md')} {
    text-align: center;
    font-size: 32px;
    line-height: 48px;
    color: var(--white-color);
  }
`;

const SCTitle = styled.h4`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 48px;
  text-align: center;
  
  color: var(--white-color);
  
  ${lessThan('md')} {
    text-align: center;
  }
`;

const SCBlock = styled.div`
  display: flex;
  flex-direction: column; 
  align-items: flex-start;
  width: 100%;
  position: relative;
  
  ${lessThan('md')} {
    align-items: center;
  }
`;

const SCAboutPage = styled.div`
`;

const SCContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  padding-left: 100px;
  padding-right: 100px;
  padding-bottom: 126px;
  
  ${lessThan('md')} {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const SCForWritersBackground = styled.div`
  background-color: var(--white-color);
`;

const SCForReadersBackground = styled.div`
  position: relative;
  background-color: #2D3848;
`;

const SCHeaderRow = styled(SCRow)`
  margin-bottom: 185px;
  margin-top: 144px;
  
  ${SCBlock} {
    max-width: 557px;
    z-index: 2;
  }
  
  ${SCBigTitle} {
    margin-bottom: 32px;
  }
  
  ${SCBigText} {
    margin-bottom: 32px;
  }
  
  ${lessThan('md')} {
    margin-bottom: 158px;
    margin-top: 82px;
    
    ${SCBlock} {
      max-width: 288px;
      z-index: 2;
    }
    
    ${SCBigTitle} {
      margin-bottom: 8px;
    }
    
    ${SCBigText} {
      margin-bottom: 30px;
    }
  }
`;

const SCForAuthorRow = styled(SCRow)`
  margin-bottom: 72px;
  
  ${SCBlock} {
    align-items: center;
  }
  
  ${SCMediumTitle} {
    margin-bottom: 4px;
  }
  
  ${SCSubtitle} {
    margin-bottom: 54px;
    color: #70797B;
  }
  
  ${lessThan('md')} {
    margin-bottom: 32px;
  }
`;

const SCAbilityTextContentBlock = styled(SCBlock)`
  max-width: 463px;
  margin-top: auto;
  margin-bottom: auto;
  
  ${SCSmallTitle} {
    margin-bottom: 32px;
  }
  
  ${SCSmallText} {
    margin-bottom: 32px;
  }
  
  ${lessThan('md')} {
    margin-top: 144px;
  }
`;

const SCAbilitiesRow = styled(SCRow)`
  margin-bottom: 144px;
  min-height: 516px;
  
  ${lessThan('md')} {
    margin-bottom: 72px;
  }
`;

const SCAudienceLinkRow = styled(SCRow)`
  margin-bottom: 58px;
  
  ${SCBlock} {
    max-width: 420px;
  }
  
  ${lessThan('md')} {
    margin-bottom: 64px;
    
    ${SCBlock}:nth-child(1) {
      margin-bottom: 64px;
    }
  }
  
`;

const SCGoodEconomyRow = styled(SCRow)`
  
  ${SCBlock} {
    max-width: 420px;
  }
`;

const SCOwnAudienceRow = styled(SCRow)`
  margin-bottom: 88px;
  
  ${lessThan('md')} {
    margin-bottom: -70px; 
  } 
`;

const SCForReadersRow = styled(SCRow)`
  margin-bottom: 136px;
  margin-top: 106px;
  

  
  ${SCBlock} {
    align-items: center;
  }
  
  ${SCMediumTitle} {
    margin-bottom: 22px;
    color: var(--white-color);
  }
  
  ${SCSubtitle} {
    margin-bottom: 80px;
    color: var(--gray3-color);
  }
  
  ${lessThan('md')} {
    margin-top: 56px; 
    margin-bottom: 150px;
    
    ${SCMediumTitle} {
      margin-bottom: 4px;
    }
    
    ${SCSubtitle} {
      margin-bottom: 25px;
    }
  } 
`;

const SCLibraryRow = styled(SCRow)`
  ${SCBlock} {
    max-width: 420px;
  }
  
  ${SCSmallTitle} {
    color: var(--white-color);
  }
  
  ${SCSmallText} {
    color: var(--gray3-color);
  }
  
  ${lessThan('md')} {

   ${SCBlock} {
    align-items: flex-start;
  }
     
   ${SCSmallTitle} {
    text-align: left;
   }
    
    ${SCSmallText} {
      text-align: left;
    }
  } 
`;

const SCRecommendationsRow = styled(SCRow)`
  margin-bottom: 103px;
  
  ${SCBlock} {
    max-width: 420px;
  }
  
  ${SCSmallTitle} {
    color: var(--white-color);
  }
  
  ${SCSmallText} {
    color: var(--gray3-color);
  }
  
  
  ${lessThan('md')} {
   margin-bottom: 25px;
   ${SCBlock} {
    align-items: flex-start;
  }
     
   ${SCSmallTitle} {
    text-align: left;
    margin-bottom: 24px;
   }
    
    ${SCSmallText} {
      text-align: left;
    }
  } 
`;

const SCPersonalRecommendationContentBlock = styled(SCBlock)`
  margin-top: auto;
  margin-bottom: auto;
`;

const SCPersonalRecommendationsRow = styled(SCRow)`
  margin-bottom: 200px;
  
  ${lessThan('md')} {
    flex-direction: column-reverse;
     
   ${SCSmallTitle} {
    text-align: left;
   }
    
    ${SCSmallText} {
      text-align: left;
    }
  } 
`;

const SCSupportRow = styled(SCRow)`
  ${SCBlock} {
    max-width: 420px;
  }
  
  ${SCSmallTitle} {
    color: var(--white-color);
  }
  
  ${SCSmallText} {
    color: var(--gray3-color);
  }
  
  
  ${lessThan('md')} { 
  
   margin-bottom: -85px;
     
   ${SCBlock} {
    align-items: flex-start;
  }
     
   ${SCSmallTitle} {
    text-align: left;
   }
    
    ${SCSmallText} {
      text-align: left;
    }
  } 
`;

const SCInformationRow = styled(SCRow)`
  margin-bottom: 78px;
  
  ${SCBlock} {
    max-width: 420px;
  }
  
  ${SCSmallTitle} {
    color: var(--white-color);
  }
  
  ${SCSmallText} {
    color: var(--gray3-color);
  }
  
  ${lessThan('md')} {
    margin-bottom: 25px;
     
   ${SCBlock} {
    align-items: flex-start;
  }
     
   ${SCSmallTitle} {
    text-align: left;
    margin-bottom: 24px;
   }
    
    ${SCSmallText} {
      text-align: left;
    }
  } 
  
`;

const SCFirstInformationContentBlock = styled(SCBlock)`
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 100px;
  
  ${lessThan('md')} {
    margin-left: unset;
  } 
`;

const SCFirstInformationRow = styled(SCRow)`
  margin-bottom: 155px;
  min-height: 589px;
`;

const SCCommunityRow = styled(SCRow)`
  margin-bottom: 84px;
  
  ${SCBlock} {
    max-width: 420px;
  }
  
  ${SCSmallTitle} {
    color: var(--white-color);
  }
  
  ${SCSmallText} {
    color: var(--gray3-color);
  }
  
  
  ${lessThan('md')} {
    margin-bottom: 25px;
    
     ${SCBlock} {
      align-items: flex-start;
    }
       
    ${SCSmallTitle} {
      margin-bottom: 24px;
      text-align: left;
    }
    
    ${SCSmallText} {
      text-align: left;
    }
  } 
`;

const SCWritersRow = styled(SCRow)`
  margin-bottom: 84px;
  
  ${SCBlock} {
    max-width: 420px;
  }
  
  ${SCSmallTitle} {
    color: var(--white-color);
  }
  
  ${SCSmallText} {
    color: var(--gray3-color);
  }
  
  
  ${lessThan('md')} {
     
   ${SCBlock} {
    align-items: flex-start;
  }
     
   ${SCSmallTitle} {
    text-align: left;
   }
    
    ${SCSmallText} {
      text-align: left;
    }
  } 
`;

const SCBookCommunityContentBlock = styled(SCBlock)`
  margin-top: auto;
  margin-bottom: auto;
`;

const SCBookCommunityRow = styled(SCRow)`
  margin-bottom: 228px;
  min-height: 585px;
  
  ${lessThan('md')} {
   margin-bottom: -30px;

    flex-direction: column-reverse;
  }
`;

const SCJoinUsRow = styled(SCRow)`
  margin-bottom: 68px;
  
  ${SCBlock} {
    max-width: 756px;
    margin-left: auto;
    margin-right: auto;
  }
  
  ${SCTitle} {
    margin-bottom: 14px;
    color: var(--white-color);
   
  }
  
  ${SCSubtitle} {
    color: #868F9B;
  }
  
   ${lessThan('md')} {
    margin-bottom: 36px;
    
    ${SCTitle} {
     font-size: 20px;
     line-height: 28px;
    }
  
    ${SCSubtitle} {
      font-size: 16px;
      line-height: 24px;
    }
   }
`;

const SCButtonsRow = styled(SCRow)`
  margin-bottom: 126px;
  
  ${lessThan('md')} {
    margin-bottom: 62px;
 }
`;
